import { getEbookDetail } from 'lib/api/ebook';
import { emptyObject } from 'utils/general';
import create from 'zustand';
import { IEBook, IEbookDetailItem } from './types';

interface EbookState {
  ebookCatalogue: IEBook[];
  ebookDetail: IEbookDetailItem;
  isEbookPageViewAsMobile: boolean;
  isPaneActive: boolean;
}

interface EbookAction {
  setEbookPageViewAsMobile: (isViewAsMobile: boolean) => void;
  setIsPaneActive: (isActive: boolean) => void;
  getEbookDetail: (url: string) => void;
}

const initialState = {
  ebookCatalogue: [],
  ebookDetail: null,
  isEbookPageViewAsMobile: false,
  isPaneActive: false,
};

const useEbookStore = create<EbookState & EbookAction>((set) => ({
  ...initialState,

  setEbookPageViewAsMobile: (isViewAsMobile: boolean) =>
    set({
      isEbookPageViewAsMobile: isViewAsMobile,
    }),

  setIsPaneActive: (isPaneActive: boolean) => set({ isPaneActive }),
  getEbookDetail: async (url: string) => {
    try {
      const response = await getEbookDetail(url);

      if (!response.data || emptyObject(response.data)) {
        throw new Error('Attempt to get ebook detail Failed');
      }

      set({ ebookDetail: response.data.data, isPaneActive: true });
      return response.data;
    } catch (error) {
      return { error };
    }
  },
}));

export default useEbookStore;
